<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    opacity="0.2"
    x="2"
    y="2"
    width="16"
    height="16"
    rx="2"
    fill="currentColor"
  />
  <path d="M9 6H11V9H14V11H11V14H9V11H6V9H9V6Z" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V4ZM4 4H16V16H4V4Z"
    fill="currentColor"
  />
</svg>
